import barba from '@barba/core';
import { gsap } from 'gsap';

export class AjaxPageHandler {
    constructor() {

    }

	maskOn(callback) {
		gsap.timeline({
			paused: true,
			reversed: true,
			onComplete: () => {
				if (typeof callback === "function")
					callback();
			}
		})
		.fromTo('main, footer', {autoAlpha: 1}, {
			autoAlpha: 0, 
			ease: "power2.inout", 
			duration: 0.3
		})
		.play();
    }

    maskOff(callback) {
		var me = this;
		gsap.timeline({onComplete: callback})
		.fromTo('main, footer', {autoAlpha: 0}, {
			autoAlpha: 1, 
			ease: "power2.inout", 
			duration: 0.3
		}, "+=0.5")
    }
    
    init() {
       
    }

    destroy() {

    }
}